export default "__VITE_ASSET__DX8L7gP9__"